var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.valueOld)?_c('ContactPerson',{staticClass:"event-history-change-prop_old",attrs:{"item":_vm.valueOld}}):_vm._e(),(_vm.valueNew)?_c('ContactPerson',{staticClass:"event-history-change-prop_new",attrs:{"item":_vm.valueNew}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }